import LazyLoad from "vanilla-lazyload";
//import Masonry from "masonry-layout";
import Cookies from "js-cookie";
const Flickity = require("flickity-fade");
import socialIcons from "social-icons";
import arRows from "ar-rows";
import gsap, { snap } from "gsap";
import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import { ScrollToPlugin } from "gsap/ScrollToPlugin";
import { Observer } from "gsap/Observer";
import { SplitText } from "gsap/SplitText";
gsap.registerPlugin(
  ScrollTrigger,
  ScrollSmoother,
  ScrollToPlugin,
  Observer,
  SplitText,
);
import zenscroll from "zenscroll";
//import fullpage from "fullpage.js";

/* SETUP VARS */
let bw = document.body.scrollWidth;
let dpr = window.devicePixelRatio;
const body = document.querySelector("body");
const menuBtn = document.querySelector(".menuBtn");
let socialEl = document.querySelectorAll(".social");
let rowsEl = document.querySelectorAll(".ar-rows");
const nav = document.querySelector("nav");
const overlay = document.getElementById("overlay");
let overlayInner, overlayCloser;
if (typeof overlay != "undefined" && overlay != null) {
  overlayInner = overlay.querySelector(".inner");
  overlayCloser = overlay.querySelector(".closer");
}

window.addEventListener("load", function () {
  body.classList.remove("preload");
});

document.addEventListener("DOMContentLoaded", function () {
  /* ***************************************** */
  /* INITIALIZATION ON PAGE LOAD */
  /* ***************************************** */

  if (!body.classList.contains("noscroll")) {
    window.smoother = ScrollSmoother.create({
      smooth: 0.5, // how long (in seconds) it takes to "catch up" to the native scroll position
      effects: true, // looks for data-speed and data-lag attributes on elements
      smoothTouch: 0, // much shorter smoothing time on touch devices (default is NO smoothing on touch devices)
    });
  }

  // check for hash values, if found, use zenscroll to scroll to the element smoothly
  if (window.location.hash) {
    setTimeout(() => {
      const target = document.querySelector(window.location.hash);
      if (target) {
        (zenscroll.to(target), { duration: 0.3 });
      }
    }, 200); // delay to allow page to load and smoother to initialize
  }

  // on mobile only I want to reset all data-speed attributes to 1 to disable parallax effects for performance
  if (window.innerWidth <= 768) {
    const parallaxElements = document.querySelectorAll("[data-speed]");
    parallaxElements.forEach((el) => {
      el.setAttribute("data-speed", "1");
    });
  }

  function moveBackgroundToWrapper(block, wrapper) {
    const backgroundImg = block.querySelector("img.background");
    if (backgroundImg) {
      wrapper.insertBefore(backgroundImg, block);
    }
  }

  // check for text-block + text-block adjacent and wrap in "text-blocks" container for styling
  let textBlocks = document.querySelectorAll(".text-block");
  for (var i = 0; i < textBlocks.length; i++) {
    let currentBlock = textBlocks[i];
    let nextBlock = currentBlock.nextElementSibling;
    if (nextBlock && nextBlock.classList.contains("text-block")) {
      let wrapper = document.createElement("div");
      wrapper.classList.add("text-blocks");
      currentBlock.parentNode.insertBefore(wrapper, currentBlock);
      wrapper.appendChild(currentBlock);
      wrapper.appendChild(nextBlock);
      moveBackgroundToWrapper(currentBlock, wrapper);
      moveBackgroundToWrapper(nextBlock, wrapper);
    }
  }

  function heroTextInit(hero) {
    let heroText = hero.querySelector(".hero_text");

    if (heroText) {
      // Get headings and paragraphs
      let headings = heroText.querySelectorAll("h1, h2");
      let paragraphs = heroText.querySelectorAll("p");

      // Set initial state for paragraphs (hidden)
      if (paragraphs.length) {
        gsap.set(paragraphs, { autoAlpha: 0 });
      }

      // Split headings by lines and animate
      let tl = gsap.timeline({ delay: 0.3 });

      headings.forEach((heading) => {
        // Wrap heading content in a div to prevent line-split overflow issues
        let split = new SplitText(heading, { type: "lines" });
        let lines = split.lines;

        // Set initial state for lines
        gsap.set(lines, { autoAlpha: 0, y: 30 });

        // after the splits are set, bring on the hero text element - stops flicker of content
        gsap.set(heroText, { autoAlpha: 1 });

        // Animate each line with stagger: fade on + float up
        tl.to(lines, {
          autoAlpha: 1,
          y: 0,
          duration: 0.8,
          ease: "power3.out",
          stagger: 0.15,
        });
      });

      // After headings finish, fade in paragraphs
      if (paragraphs.length) {
        tl.to(paragraphs, {
          autoAlpha: 1,
          duration: 0.6,
          ease: "power2.out",
          stagger: 0.1,
        });
      }
    }
  }

  let heroEl = document.querySelectorAll(".hero");
  heroEl.forEach((hero) => {
    heroTextInit(hero);
  });

  // Two-column text animations triggered on scroll
  function twoColumnTextInit(el) {
    let headings = el.querySelectorAll("h1, h2, h3");
    let paragraphs = el.querySelectorAll("p");

    // Set initial state for headings (split by lines) and paragraphs
    let allSplits = [];
    headings.forEach((heading) => {
      let split = new SplitText(heading, { type: "lines" });
      allSplits.push(split);
      gsap.set(split.lines, { autoAlpha: 0, y: 30 });
    });

    if (paragraphs.length) {
      gsap.set(paragraphs, { autoAlpha: 0 });
    }

    // Build timeline (paused, triggered by ScrollTrigger)
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: "top center+=200",
        once: true,
      },
    });

    allSplits.forEach((split) => {
      tl.to(split.lines, {
        autoAlpha: 1,
        y: 0,
        duration: 0.5,
        ease: "power3.out",
        stagger: 0.15,
      });
    });

    if (paragraphs.length) {
      tl.to(paragraphs, {
        autoAlpha: 1,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.3,
      });
    }
  }

  let twoColEls = document.querySelectorAll(".text-block .two-column");
  twoColEls.forEach((el) => {
    twoColumnTextInit(el);
  });

  // Text block column animations triggered on scroll
  function textBlockColumnInit(el) {
    let headings = el.querySelectorAll("h1, h2, h3");
    let paragraphs = el.querySelectorAll("p");

    // Split headings by lines and set initial state
    let allSplits = [];
    headings.forEach((heading) => {
      let split = new SplitText(heading, { type: "lines" });
      allSplits.push(split);
      gsap.set(split.lines, { autoAlpha: 0, y: 30 });
    });

    if (paragraphs.length) {
      gsap.set(paragraphs, { autoAlpha: 0 });
    }

    // Build timeline triggered by ScrollTrigger
    let tl = gsap.timeline({
      scrollTrigger: {
        trigger: el,
        start: "top center+=200",
        once: true,
      },
    });

    allSplits.forEach((split) => {
      tl.to(split.lines, {
        autoAlpha: 1,
        y: 0,
        duration: 0.8,
        ease: "power3.out",
        stagger: 0.15,
      });
    });

    if (paragraphs.length) {
      tl.to(paragraphs, {
        autoAlpha: 1,
        duration: 0.6,
        ease: "power2.out",
        stagger: 0.1,
      });
    }
  }

  // Exclude columns already handled by the two-column animation
  let textBlockColumns = document.querySelectorAll(
    ".text-block .column:not(.two-column .column)",
  );
  textBlockColumns.forEach((el) => {
    textBlockColumnInit(el);
  });

  // Talent detail page heading animation - split h1 by chars, fade on + float up, then fade breadcrumb
  function talentDetailHeadingInit() {
    let pageHeading = document.querySelector(".talentdetail .page-heading");
    if (!pageHeading) return;

    let h1 = pageHeading.querySelector("h1");
    let breadcrumb = pageHeading.querySelector(".breadcrumb");
    let split;

    if (h1) {
      split = new SplitText(h1, { type: "chars" });
      gsap.set(split.chars, { autoAlpha: 0, y: 20 });
    }

    if (breadcrumb) {
      gsap.set(breadcrumb, { autoAlpha: 0 });
    }

    gsap.set(pageHeading, { autoAlpha: 1 }); // ensure page heading is visible before animating children to prevent flicker

    let tl = gsap.timeline({ delay: 0.3 });

    if (split) {
      tl.to(split.chars, {
        autoAlpha: 1,
        y: 0,
        duration: 0.6,
        ease: "power3.out",
        stagger: 0.03,
      });
    }

    if (breadcrumb) {
      tl.to(breadcrumb, {
        autoAlpha: 1,
        duration: 0.6,
        ease: "power2.out",
      });
    }
  }

  talentDetailHeadingInit();

  function homeInit() {
    // Custom cursor for home hero
    const homeHero = document.querySelector(".home .hero");
    if (homeHero) {
      // console.log("Initializing custom cursor");
      const cursorEl = document.createElement("div");
      cursorEl.className = "custom-cursor";
      document.body.appendChild(cursorEl);

      let mouseX = 0;
      let mouseY = 0;
      let rafId = null;

      const render = () => {
        cursorEl.style.transform = `translate(${mouseX}px, ${mouseY}px) translate(-50%, -50%)`;
        rafId = null;
      };

      const onMove = (e) => {
        mouseX = e.clientX;
        mouseY = e.clientY;
        if (!rafId) rafId = requestAnimationFrame(render);
      };

      homeHero.addEventListener("mouseenter", () => {
        cursorEl.classList.add("is-visible");
      });

      homeHero.addEventListener("mouseleave", () => {
        cursorEl.classList.remove("is-visible");
      });

      homeHero.addEventListener("mousemove", onMove);
    }
  }

  // custom circles

  let animateCirclesRef = null;

  function circlesInit() {
    const circles = document.querySelectorAll(".circle");
    const drawer = document.querySelector(".circles #drawer");
    const resetLink = drawer.querySelector(".reset");
    const resetSceneLink = document.querySelector(".scene_reset");

    // custom reset link to remove all selected states and close drawer

    [resetLink, resetSceneLink].forEach((link) => {
      if (link) {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          document.querySelectorAll(".circle.selected").forEach((c) => {
            c.classList.remove("selected");
          });

          drawer.classList.remove("open");
          if (animateCirclesRef) animateCirclesRef(false);

          setTimeout(function () {
            // remove active class from all #drawer .service elements
            document.querySelectorAll("#drawer .service").forEach((s) => {
              s.classList.remove("active");
            });
          }, 500);
        });
      }
    });

    // Normalized mouse position (-1 to 1)
    let mx = 0,
      my = 0;
    window.addEventListener("mousemove", (e) => {
      mx = (e.clientX / window.innerWidth) * 2 - 1;
      my = (e.clientY / window.innerHeight) * 2 - 1;
    });

    // Track drawer state for float/parallax reduction
    let isDrawerOpen = false;

    const isMobile = window.innerWidth <= 768;

    console.log(
      isMobile
        ? "Initializing circles with mobile config"
        : "Initializing circles with desktop config",
    );

    // Per-circle float & parallax config
    // openLeft/openTop = where circles reposition when drawer opens
    const config = [
      {
        floatX: isMobile ? 10 : 24,
        floatY: isMobile ? 12 : 28,
        speedX: 5.2,
        speedY: 6.8,
        depth: isMobile ? 0.01 : 0.02,
        lerp: 0.03,
        openLeft: isMobile ? "5%" : "24%",
        openTop: isMobile ? "2%" : "15%",
      },
      {
        floatX: isMobile ? 8 : 22,
        floatY: isMobile ? 8 : 16,
        speedX: 7.1,
        speedY: 5.5,
        depth: isMobile ? 0.03 : 0.06,
        lerp: 0.08,
        openLeft: isMobile ? "55%" : "3%",
        openTop: isMobile ? "2%" : "22%",
      },
      {
        floatX: isMobile ? 8 : 20,
        floatY: isMobile ? 10 : 24,
        speedX: 6.3,
        speedY: 8.1,
        depth: isMobile ? 0.02 : 0.035,
        lerp: 0.045,
        openLeft: isMobile ? "5%" : "42%",
        openTop: isMobile ? "16%" : "53%",
      },
      {
        floatX: isMobile ? 8 : 20,
        floatY: isMobile ? 8 : 18,
        speedX: 5.8,
        speedY: 7.4,
        depth: isMobile ? 0.008 : 0.015,
        lerp: 0.025,
        openLeft: isMobile ? "55%" : "46%",
        openTop: isMobile ? "16%" : "20%",
      },
      {
        floatX: isMobile ? 6 : 16,
        floatY: isMobile ? 8 : 20,
        speedX: 8.2,
        speedY: 5.9,
        depth: isMobile ? 0.03 : 0.07,
        lerp: 0.09,
        openLeft: isMobile ? "5%" : "3%",
        openTop: isMobile ? "30%" : "58%",
      },
      {
        floatX: isMobile ? 10 : 24,
        floatY: isMobile ? 6 : 14,
        speedX: 6.7,
        speedY: 7.2,
        depth: isMobile ? 0.02 : 0.04,
        lerp: 0.05,
        openLeft: isMobile ? "55%" : "22%",
        openTop: isMobile ? "30%" : "56%",
      },
      {
        floatX: isMobile ? 8 : 19,
        floatY: isMobile ? 8 : 21,
        speedX: 7.5,
        speedY: 6.1,
        depth: isMobile ? 0.012 : 0.025,
        lerp: 0.035,
        openLeft: isMobile ? "30%" : "42%",
        openTop: isMobile ? "44%" : "58%",
      },
    ];

    // Entrance animation
    gsap.to(circles, {
      opacity: 1,
      scale: 1,
      duration: 1.1,
      ease: "expo.out",
      stagger: { amount: 0.8, from: "random" },
    });

    // Build per-circle state with random phase offsets
    const state = config.map(
      ({ floatX, floatY, speedX, speedY, depth, lerp }) => ({
        floatX,
        floatY,
        speedX,
        speedY,
        depth,
        lerp,
        phaseX: Math.random() * 1000,
        phaseY: Math.random() * 1000,
        px: 0,
        py: 0,
      }),
    );

    // Cache node references
    const nodes = Array.from(document.querySelectorAll(".circle"));

    const startTime = performance.now();
    const globalSpeed = 1.2;

    // Single ticker: combines idle float + mouse parallax
    gsap.ticker.add(() => {
      const t = ((performance.now() - startTime) / 1000) * globalSpeed;

      state.forEach((s, i) => {
        const node = nodes[i];
        if (!node) return;

        // Reduce float and parallax range when drawer is open
        const floatScale = isDrawerOpen ? 0.4 : 1;
        const parallaxScale = isDrawerOpen ? 0.5 : 1;

        // Independent sine float on each axis
        const fx =
          Math.sin((t + s.phaseX) / (s.speedX / (2 * Math.PI))) *
          s.floatX *
          floatScale;
        const fy =
          Math.cos((t + s.phaseY) / (s.speedY / (2 * Math.PI))) *
          s.floatY *
          floatScale;

        // Smoothly lerp parallax toward mouse target
        const targetPX = mx * window.innerWidth * s.depth * parallaxScale;
        const targetPY = my * window.innerHeight * s.depth * parallaxScale;
        s.px += (targetPX - s.px) * s.lerp;
        s.py += (targetPY - s.py) * s.lerp;

        gsap.set(node, {
          x: fx + s.px,
          y: fy + s.py,
        });
      });
    });

    // Animate circles to their open/closed positions
    function animateCircles(open) {
      isDrawerOpen = open;
      body.classList.toggle("drawer-open", open);

      config.forEach((c, i) => {
        const node = nodes[i];
        if (!node) return;

        if (open) {
          gsap.to(node, {
            left: c.openLeft,
            top: c.openTop,
            scale: isMobile ? 0.55 : 0.75,
            duration: 0.6,
            ease: "power2.inOut",
          });
        } else {
          // Read CSS-defined position using an offscreen clone to avoid visual flash
          const clone = node.cloneNode(false);
          clone.style.cssText = "";
          clone.style.visibility = "hidden";
          clone.style.position = "absolute";
          clone.style.pointerEvents = "none";
          node.parentNode.appendChild(clone);
          const cssLeft = getComputedStyle(clone).left;
          const cssTop = getComputedStyle(clone).top;
          clone.remove();

          gsap.to(node, {
            left: cssLeft,
            top: cssTop,
            scale: 1,
            duration: 0.6,
            ease: "power2.inOut",
            onComplete: () => {
              // Clear inline left/top so CSS stays in control (keep scale to avoid pop)
              gsap.set(node, { clearProps: "left,top" });
            },
          });
        }
      });
    }

    // Expose so menuBtn handler can use it
    animateCirclesRef = animateCircles;

    // Click: toggle selected with elastic bounce
    circles.forEach((circle) => {
      if (innerWidth > 768) {
        circle.addEventListener("mouseenter", () => {
          if (circle.classList.contains("selected")) return; // skip hover effect if selected
          const contents = circle.querySelector(".subtext");
          if (contents) {
            const contentsInner = contents.querySelector(".contents");
            const height = contentsInner.scrollHeight;
            contents.style.height = `${height}px`;
          }
        });
        circle.addEventListener("mouseleave", () => {
          const contents = circle.querySelector(".subtext");
          if (contents) {
            contents.style.height = "0";
          }
        });
      }
      circle.addEventListener("click", () => {
        // Toggle this circle's selected state
        circle.classList.toggle("selected");

        // get the circle ID
        const circleId = circle.getAttribute("data-id");

        if (circle.classList.contains("selected")) {
          // show corresponding content in drawer
          const contentToShow = drawer.querySelector(
            `.service[data-id="${circleId}"]`,
          );
          if (contentToShow) {
            contentToShow.classList.add("active");
          }
        } else {
          // hide corresponding content in drawer
          const contentToHide = drawer.querySelector(
            `.service[data-id="${circleId}"]`,
          );
          if (contentToHide) {
            contentToHide.classList.remove("active");
          }
        }

        // Determine if any circles remain selected
        const anySelected =
          document.querySelectorAll(".circle.selected").length > 0;

        // Open/close drawer based on whether any circles are selected
        if (anySelected) {
          drawer.classList.add("open");
          document.querySelector(".menuBtn p").innerText = "CLOSE";
        } else {
          drawer.classList.remove("open");
          document.querySelector(".menuBtn p").innerText = "MENU";
        }

        animateCircles(anySelected);

        // Only run the bounce effect when opening (selecting circles)
        // When closing, animateCircles handles the smooth scale-back-to-1
        if (anySelected) {
          gsap
            .timeline()
            .to(circle, {
              scale: isMobile ? 0.5 : 0.7,
              duration: 0.12,
              ease: "power2.in",
            })
            .to(circle, {
              scale: isMobile ? 0.55 : 0.75,
              duration: 0.45,
              ease: "elastic.out(1, 0.5)",
            });
        }
      });
    });
  }

  const circlesEl = document.querySelector(".circles");
  if (typeof circlesEl != "undefined" && circlesEl != null) {
    circlesInit();
  }

  // check for any social icons
  if (typeof socialIcons != "undefined") {
    socialIcons(socialEl);
  }

  // init AR Rows type layout
  if (typeof arRows != "undefined") {
    arRows(rowsEl);
  }

  // any cols from text editor need to be wrapped in cols class
  let textCols = document.querySelectorAll(".text-block");
  for (var i = 0; i < textCols.length; i++) {
    wrapCols(textCols[i]);
  }

  function loadInit() {
    // global animation effects
    ScrollTrigger.batch(".fadeUp", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
      },
    });

    ScrollTrigger.batch(".fadeOn", {
      onEnter: (elements, triggers) => {
        gsap.to(elements, { opacity: 1, stagger: 0.1 });
      },
    });

    ScrollTrigger.batch(
      ".fadeOnDelay",
      {
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, stagger: 0.15 });
        },
      },
      600,
    );

    setTimeout(function () {
      ScrollTrigger.batch(".fadeUpDelay", {
        onEnter: (elements, triggers) => {
          gsap.to(elements, { opacity: 1, y: 0, stagger: 0.15 });
        },
      });
    }, 300);

    //initialize lazyload - sitewide for image
    const lazyLoad = new LazyLoad({
      elements_selector: ".loadmeview",
      callback_enter: loadImage,
    });

    //initialize lazyload - autoplay videos
    const lazyLoadAutoVideo = new LazyLoad({
      elements_selector: ".autovideo",
      threshold: 30,
      callback_enter: playAutoVideo,
      callback_exit: pauseAutoVideo,
    });

    if (window.innerWidth > 768) {
      const hoverVideoEls = document.querySelectorAll(".hovervideo");
      hoverVideoEls.forEach((videoEl) => {
        videoEl.addEventListener("mouseenter", () => {
          playAutoVideo(videoEl);
        });
        videoEl.addEventListener("mouseleave", () => {
          pauseAutoVideo(videoEl);
        });
      });
    }

    // // Fullpage JS
    // new fullpage("#fullpage", {
    //   autoScrolling: true, // keeps sections fixed, but fp-auto-height overrides
    //   fitToSection: true,
    //   scrollingSpeed: 700,
    //   // optional: hide navigation if you don't want dots
    //   navigation: false,
    //   // important: prevent fullPage from adding scrollbar to body
    //   scrollBar: false,
    //   // allow content taller than viewport inside auto-height sections
    //   scrollOverflow: true,
    // });
  }

  loadInit();

  // loose grids

  let looseGrids = document.querySelectorAll(".grid_loose");
  looseGrids.forEach((looseGrid) => {
    let catid = looseGrid.getAttribute("data-catid");
    let grid;
    let view = "desktop";
    let resizeTimeout;

    function checkView() {
      let newView = innerWidth <= 768 ? "mobile" : "desktop";
      if (view !== newView) {
        view = newView;
        return true;
      }
      return false;
    }

    function loadGrid() {
      fetch(`/getCanvas.php?catid=${catid}&view=${view}`)
        .then((response) => response.text())
        .then((data) => {
          looseGrid.innerHTML = data;
          grid = looseGrid.querySelector("ul.canvas");

          const resizeObserver = new ResizeObserver(updatePositions);
          resizeObserver.observe(grid);

          loadInit();

          setTimeout(function () {
            updateContainerHeight();
          }, 500);
        })
        .catch((error) => console.error("Error:", error));
    }

    // Initial check and load
    checkView();
    loadGrid();

    // Debounced window resize handler
    window.addEventListener("resize", () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        if (checkView()) {
          loadGrid();
        }
      }, 250); // Wait 250ms after last resize event
    });

    function updatePositions() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      const { width, height } = grid.getBoundingClientRect();

      items.forEach((item) => {
        let percentX = parseFloat(item.dataset.x);
        let percentY = parseFloat(item.dataset.y);

        // apply the new positions as pixels
        item.style.left = `${(percentX / 100) * width}px`;
        item.style.top = `${(percentY / 100) * width}px`; // Base top on width

        // clear out transforms from draggable
        gsap.set(item, {
          x: 0,
          y: 0,
          z: 0,
        });
      });

      updateContainerHeight();
    }

    function updateContainerHeight() {
      let grid = looseGrid.querySelector("ul.canvas");
      let items = grid.querySelectorAll(".item");

      requestAnimationFrame(() => {
        let maxBottom = 0;

        items.forEach((item) => {
          let topPos = gsap.getProperty(item, "top"); // Get the top position in pixels
          itemBottom = topPos + item.offsetHeight; // Distance from top + height
          maxBottom = Math.max(maxBottom, itemBottom);
        });

        grid.style.height = `${Math.ceil(maxBottom)}px`; // Round up & add buffer for admin, on front-end this should be tight to the grid
        grid.style.minHeight = "auto";
      });
    }
  });

  // initialize masonry

  let masonGrids = document.querySelectorAll(".masongrid");
  masonGrids.forEach((masonGrid) => {
    //injecting bottom margin into masonry cell
    let gutterWidth = masonGrid.querySelector(".gutter-sizer").scrollWidth;
    let cells = masonGrid.getElementsByClassName("cell");
    for (var i = 0; i < cells.length; i++) {
      cells[i].style.marginBottom = gutterWidth + "px";
    }

    const msnry = new Masonry(masonGrid, {
      itemSelector: ".cell",
      columnWidth: ".grid-sizer",
      gutter: ".gutter-sizer",
    });
    msnry.layout();

    function onLayoutComplete() {
      // run lazyload after masonry has run
      const masonLoad = new LazyLoad({
        elements_selector: ".masonlazy",
      });
    }
    msnry.on("layoutComplete", onLayoutComplete);
  });

  //initialize flickity for slideshows

  let slideshowEl = document.querySelector(".slideshow");
  let counterEl = document.querySelector(".counter .current");

  if (typeof slideshowEl != "undefined" && slideshowEl != null) {
    let flkty = new Flickity(slideshowEl, {
      // options
      fade: true,
      cellSelector: ".cell",
    });

    // change event
    flkty.on("change", function (index) {
      let slideCount = index + 1;
      counterEl.innerHTML = slideCount;
    });
  }

  /* HANDLE CELLS THAT REQUIRE RATIO SIZING */
  let ratioCells = document.getElementsByClassName("ratioSize");
  for (let i = 0; i < ratioCells.length; i++) {
    ratioSize(ratioCells[i]);
  }

  /* HANDLE IMAGES THAT REQUIRE RESIZE IMAGE FUNCTION */
  let resizeImageCells = document.getElementsByClassName("resize-image");
  for (let i = 0; i < resizeImageCells.length; i++) {
    resizeImage(resizeImageCells[i]);
  }

  // initialize logo carousel

  function logoCarouselInit(logoCarouselEl) {
    console.log("Initializing logo carousel for element:", logoCarouselEl);

    let tickerSpeed = -1;
    let isPaused = false;
    let flktyLogos;

    const update = () => {
      if (isPaused) return;
      if (flktyLogos.slides) {
        flktyLogos.x = (flktyLogos.x + tickerSpeed) % flktyLogos.slideableWidth;
        //flktyLogos.x = flktyLogos.x * -1;

        flktyLogos.selectedIndex = flktyLogos.dragEndRestingSelect();
        flktyLogos.updateSelectedSlide();
        flktyLogos.settle(flktyLogos.x);
      }
      window.requestAnimationFrame(update);
    };

    const pause = () => {
      isPaused = true;
    };

    const play = () => {
      if (isPaused) {
        isPaused = false;
        window.requestAnimationFrame(update);
      }
    };

    flktyLogos = new Flickity(logoCarouselEl, {
      // options
      autoPlay: false,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      wrapAround: true,
      groupCells: 4,
      selectedAttraction: 0.015,
      friction: 0.25,
    });
    flktyLogos.x = 0;

    update();
  }

  function scrollingLogosInit() {
    console.log("Initializing scrolling logo carousels");
    let logoCarouselEls = document.querySelectorAll(".scrolling-logos");
    logoCarouselEls.forEach((logoCarouselEl) => {
      logoCarouselInit(logoCarouselEl);
    });
  }

  scrollingLogosInit();

  /* ***************************************** */
  /* FUNCTIONS */
  /* ***************************************** */

  function sizeloadVideo(el, preload) {
    let desktopSrc = el.getAttribute("data-hd"),
      mobileSrc = el.getAttribute("data-sd"),
      videoSourceEl = el.querySelector("source");

    if (window.innerWidth > 896) {
      videoSourceEl.setAttribute("src", desktopSrc);
    } else {
      videoSourceEl.setAttribute("src", mobileSrc);
    }
    el.load();
    if (preload !== "yes") {
      el.play();
    }
  }

  // check for any size load videos on page load
  let sizeLoadVideoEls = document.querySelectorAll("video.sizeload");
  sizeLoadVideoEls.forEach((videoEl) => {
    sizeloadVideo(videoEl, "yes");
  });

  function playAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo

    if (el.classList.contains("inline_playing")) {
      return;
    }

    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      if (!el.classList.contains("click-to-play")) {
        let playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      }
    } else {
      let videoStr = el.getAttribute("data-autovideo");
      let videoHold = el.querySelector(".vidhold");
      videoHold.innerHTML = videoStr;
      videoEl = videoHold.querySelector("video");
      if (videoEl.classList.contains("sizeload")) {
        sizeloadVideo(videoEl, "no");
      } else if (!el.classList.contains("click-to-play")) {
        let playPromise = videoEl.play();
        if (playPromise !== undefined) {
          playPromise.catch(() => {});
        }
      }
    }

    if (!el.classList.contains("click-to-play")) {
      el.classList.add("playing");
    }
  }

  /*
  let clickToPlayEls = document.querySelectorAll(".click-to-play");
  clickToPlayEls.forEach((el) => {
    el.addEventListener("click", function (e) {
      e.preventDefault();
      let videoEl = el.querySelector("video");
      el.classList.add("playing");

      if (typeof videoEl != "undefined" && videoEl != null) {
        videoEl.play();
        // console.log("Video playing");
      }
    });
  });
  */

  function pauseAutoVideo(el) {
    // if user has interacted with full video stop the hovervideo
    if (el.classList.contains("inline_playing")) {
      return;
    }
    let videoEl = el.querySelector("video");
    if (typeof videoEl != "undefined" && videoEl != null) {
      // Wait for any pending play() promise before pausing
      let playPromise = videoEl.play();
      if (playPromise !== undefined) {
        playPromise
          .then(() => {
            videoEl.pause();
          })
          .catch(() => {
            // play() was already interrupted or failed, no need to pause
          });
      } else {
        videoEl.pause();
      }
    }
    el.classList.remove("playing");
  }

  /* CUSTOM VIDEO CONTROLS */
  let projectVideoWrap, projectVideoEl;

  function goFullView(elem) {
    function onFullScreenChange() {
      if (
        document.fullscreenElement === elem ||
        document.webkitFullscreenElement === elem ||
        document.mozFullScreenElement === elem ||
        document.msFullscreenElement === elem
      ) {
        body.classList.add("videofullscreen");
      } else {
        body.classList.remove("videofullscreen");
      }
    }

    document.addEventListener("fullscreenchange", onFullScreenChange);
    document.addEventListener("webkitfullscreenchange", onFullScreenChange);
    document.addEventListener("mozfullscreenchange", onFullScreenChange);
    document.addEventListener("MSFullscreenChange", onFullScreenChange);

    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    }
  }

  function videoControls(player) {
    let isFile = true;
    player.classList.remove("embed");
    let video = player.querySelector("video");
    let videoFrame = player.querySelector("iframe");

    if (!video && !videoFrame) {
      console.warn("No video or iframe found in player:", player);
      return;
    }

    if (typeof videoFrame != "undefined" && videoFrame != null) {
      isFile = false;
      player.classList.add("embed");
      var vimeoplayer = new Player(videoFrame);
    }

    // Ensure controls are sized only after the video is ready
    let controls = player.querySelector(".controls");
    function sizeControls() {
      // get the width of the actual video element, apply 95% width to the controls and inset 2.5% on the left
      let videoWidth = video.offsetWidth;
      controls.style.width = `${videoWidth * 0.95}px`;
      player.style.opacity = 1;
    }

    if (typeof video != "undefined" && video != null) {
      // Call on loadedmetadata (video dimensions available)
      video.addEventListener("loadedmetadata", sizeControls);
      // Also call on window resize to keep in sync
      window.addEventListener("resize", sizeControls);
      // If video is already loaded, call immediately
      if (video.readyState >= 1) sizeControls();
    }

    projectVideoWrap = player;
    projectVideoEl = player.querySelector("video");
    let playIcon = player.querySelector(".playIcon");
    let playPauseBtn = player.querySelector(".playpause");
    let muteBtn = player.querySelector(".mute");
    let volumeSlider = player.querySelector("#volume-bar");
    let volumeBg = player.querySelector(".volume .bg");
    let seekSlider = player.querySelector("#seek-bar");
    let seekBg = player.querySelector(".scrubber .bg");
    let fullBtn = player.querySelector(".gofull");
    let durationEl = player.querySelector(".timestamp .duration");
    let progressEl = player.querySelector(".timestamp .progress");

    // Add spacebar play/pause support
    function handleSpacebar(event) {
      // Only trigger if player is visible/active
      if (
        player.classList.contains("on") &&
        document.activeElement.tagName !== "INPUT" &&
        document.activeElement.tagName !== "TEXTAREA"
      ) {
        if (event.code === "Space" || event.key === " ") {
          event.preventDefault();
          if (!video.paused && !video.ended) {
            video.pause();
          } else {
            video.play();
          }
        }
      }
    }

    if (isFile) {
      window.addEventListener("keydown", handleSpacebar);
      // Remove listener when player is destroyed (optional, if you have a destroy/cleanup)
      // You may want to remove this event when overlay/player is closed.
    }

    if (isFile) {
      // custom mp4 functions
      // force load of video to trigger events
      video.load();
    } else {
      // resize iframe to container size
      resizeFrame(videoFrame);
    }

    function hideVideo(event) {
      event.preventDefault();
      event.stopPropagation();

      let eventTargetEl = event.target;
      if (eventTargetEl.classList.contains("noclose")) {
        return;
      }

      projectVideoWrap.classList.remove("on");
      if (isFile) {
        video.pause();
      } else {
        vimeoplayer.pause();
      }
    }

    fullBtn.addEventListener("click", function (event) {
      event.stopPropagation();
      goFullView(player);
    });

    playIcon.addEventListener("click", function () {
      video.play();
    });

    playPauseBtn.addEventListener("click", function () {
      console.log("Play/pause button clicked");
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    });

    video.addEventListener("click", function () {
      if (!video.paused && !video.ended) {
        video.pause();
      } else {
        video.play();
      }
    });

    if (isFile) {
      // event listeners

      video.addEventListener("canplay", videoCanPlay);
      video.addEventListener("playing", videoPlaying);
      video.addEventListener("pause", videoPaused);
      video.addEventListener("timeupdate", videoTimeUpdate);
      video.addEventListener("ended", videoEnded);

      muteBtn.addEventListener("click", function (event) {
        event.stopPropagation();
        volumeToggle();
      });
      seekSlider.addEventListener("input", function (event) {
        event.stopPropagation();
        videoSeek();
      });
      volumeSlider.addEventListener("input", function (event) {
        event.stopPropagation();
        volumeChange();
      });
    }

    if (isFile) {
      // show / hide controls based on mousemovement over video
      var mousetimeout;
      player.onmousemove = function () {
        clearTimeout(mousetimeout);
        controls.classList.remove("hide");
        mousetimeout = setTimeout(function () {
          // hide video controls if no mouse movement after 2 seconds
          controls.classList.add("hide");
        }, 2000);
      };

      player.onmouseleave = function () {
        controls.classList.add("hide");
      };

      // hide controls after 2 seconds is no user action is taken
      setTimeout(function () {
        controls.classList.add("hide");
      }, 2000);
    }

    // functions

    function videoEnded() {
      player.classList.remove("playing");
      player.classList.remove("pause");
      video.currentTime = 0;
    }

    function videoCanPlay() {
      let videoW = video.offsetWidth;
      //player.style.width = videoW + "px";
      player.classList.add("on");
      video.classList.add("ready");

      var vid_duration = video.duration;
      let vid_minutes = 0;
      let vid_seconds = 0;

      vid_minutes = parseInt(vid_duration / 60);
      if (vid_minutes < 10) {
        vid_minutes = `${vid_minutes}`;
      }
      vid_seconds = parseInt(vid_duration) - vid_minutes * 60;
      if (vid_seconds < 10) {
        vid_seconds = `0${vid_seconds}`;
      }

      var vid_dur_output = `${vid_minutes}:${vid_seconds}`;
      durationEl.innerHTML = vid_dur_output;
    }

    function videoPlaying() {
      player.classList.add("playing");
      player.classList.remove("paused");
      body.classList.add("videoplaying");
    }

    function videoPaused() {
      player.classList.remove("playing");
      player.classList.add("paused");
      body.classList.remove("videoplaying");
    }

    function videoTimeUpdate() {
      let rawTime = video.currentTime;
      let minutes = 0;
      let seconds = 0;

      minutes = parseInt(rawTime / 60);
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      seconds = parseInt(rawTime) - minutes * 60;
      if (seconds < 10) {
        seconds = `0${seconds}`;
      }

      let output = `${minutes}:${seconds}`;
      progressEl.innerHTML = output;

      // Calculate the slider value
      var value = (100 / video.duration) * video.currentTime;

      // Update the slider value and bg value
      seekSlider.value = value;
      seekBg.style.width = value + "%";
    }

    function videoSeek() {
      // Calculate the new time
      var time = video.duration * (seekSlider.value / 100);

      // Update the video time
      video.currentTime = time;
    }

    function volumeToggle() {
      if (video.muted == false) {
        video.muted = true;
        player.classList.add("muted");
      } else {
        video.muted = false;
        player.classList.remove("muted");
      }
    }

    function volumeChange() {
      video.volume = volumeSlider.value;
      volumeBg.style.width = volumeSlider.value * 100 + "%";
    }
  }

  // check for any videoplayer elements and create custom controls
  let videoPlayerEls = document.querySelectorAll(".videoplayer");
  videoPlayerEls.forEach((player) => {
    videoControls(player);
  });

  function loadImage(image) {
    let img = image.getAttribute("data-img"),
      newW = image.classList.contains("bg-loadme")
        ? image.offsetWidth * dpr
        : image.parentNode.offsetWidth * dpr,
      fullpath = "",
      imgpath = "";

    const path = "";

    if (!image.classList.contains("gif")) {
      if (newW <= 500) {
        imgpath = "/images/pics/500/" + img;
      } else if (newW > 500 && newW <= 750) {
        imgpath = "/images/pics/750/" + img;
      } else if (newW > 750 && newW <= 1000) {
        imgpath = "/images/pics/1000/" + img;
      } else if (newW > 1000 && newW <= 1536) {
        imgpath = "/images/pics/1536/" + img;
      } else if (newW > 1536 && newW <= 1920) {
        imgpath = "/images/pics/1920/" + img;
      } else {
        imgpath = "/images/pics/" + img;
      }
    } else {
      // load jpg as placeholder, when gif loaded swap
      imgpath = "/images/pics/500/" + img;
      fullpath = "/images/pics/" + img;

      var fullimg = new Image();
      fullimg.onload = function () {
        var fullImgSrc = fullimg.getAttribute("src");
        image.src = fullImgSrc;
        //$('.photo[data-src="' + img + '"]').attr("src", fullImgSrc);
      };
      fullimg.src = path + fullpath;
    }

    if (image.classList.contains("bg-loadme")) {
      $("<img/>")
        .attr("src", imgpath)
        .on("load", function () {
          $(this).remove();
          image
            .css("background-image", "url(" + path + imgpath + ")")
            .addClass("loaded");
        });
    } else {
      let newimage = new Image();
      newimage.onload = function () {
        image.src = path + imgpath;
        //image.classList.add("loaded");
      };
      newimage.src = path + imgpath;
    }
  }

  function wrapCols(el) {
    let elContainer = document.createElement("div");
    Array.prototype.forEach.call(el.querySelectorAll(".col"), function (c) {
      elContainer.appendChild(c);
    });
    elContainer.classList.add("cols");
    el.appendChild(elContainer);
  }

  // AJAX GET
  function getAjax(url, success) {
    var xhr = window.XMLHttpRequest
      ? new XMLHttpRequest()
      : new ActiveXObject("Microsoft.XMLHTTP");
    xhr.open("GET", url);
    xhr.onreadystatechange = function () {
      if (xhr.readyState > 3 && xhr.status == 200) success(xhr.responseText);
    };
    xhr.setRequestHeader("X-Requested-With", "XMLHttpRequest");
    xhr.send();
    return xhr;
  }

  function openOverlay() {
    overlay.classList.add("on");
  }

  function closeOverlay() {
    overlay.classList.remove("on");
    overlayInner.innerHTML = "";
    overlayInner.classList.remove("reel");
  }

  function ratioSize(el) {
    let width = el.scrollWidth,
      ratio = el.getAttribute("data-ratio"),
      height = Math.floor(width * ratio);

    el.style.height = height + "px";
  }

  function resizeImage(el) {
    let photo = el.getElementsByClassName("photo"),
      parentWidth = Math.floor(el.scrollWidth),
      parentHeight = Math.floor(el.scrollHeight),
      parentRatio = parentHeight / parentWidth,
      photoRatio = photo[0].getAttribute("data-aspect-ratio");

    if (photoRatio >= parentRatio) {
      photo[0].classList.add("size-width");
      photo[0].classList.remove("size-height");
    } else {
      photo[0].classList.add("size-height");
      photo[0].classList.remove("size-width");
    }
  }

  function resizeFrame(el) {
    let parent = el.closest(".vidhold"),
      pw = parent.offsetWidth,
      ph = parent.offsetHeight,
      pr = ph / pw,
      orgW = el.getAttribute("width"),
      orgH = el.getAttribute("height"),
      r = orgH / orgW;

    if (r <= pr) {
      var nw = pw;
      var nh = nw * r;
    } else {
      var nw = ph / r,
        nh = ph;
    }

    el.setAttribute("width", nw);
    el.setAttribute("height", nh);
  }

  /* HANDLE WINDOW RESIZE */

  function reportWindowSize() {}

  window.addEventListener("resize", reportWindowSize);

  /* ***************************************** */
  /* EVENTS */
  /* ***************************************** */
  // Intro sequence
  let introSequence = document.querySelector(".intro-sequence");
  if (typeof introSequence != "undefined" && introSequence != null) {
    let introText = introSequence.querySelector(".intro_text");
    let introMedia = introSequence.querySelector(".intro_media");
    let vidhold = introMedia.querySelector(".vidhold");

    setTimeout(function () {
      let videoEl = vidhold.querySelector("video");
      if (typeof videoEl != "undefined" && videoEl != null) {
        videoEl.play();
      }
    }, 100);

    // delaying load of homepage content for better intro performance.
    setTimeout(function () {
      loadHome();
    }, 1000);

    let introTL = gsap.timeline({
      onComplete: () => {
        document.body.classList.remove("intro_playing");
        // set a cookie valid for this session only to prevent intro from playing again until user leaves the site
        Cookies.set("introPlayed", "true", { expires: 1 / 24 });
      },
    });

    introTL
      .to(
        introMedia,
        {
          scale: 0.6,
          duration: 1.25,
          translateY: "-30%",
          ease: "power3.out",
        },
        1.5,
      )
      .to(
        introText,
        {
          clipPath: "inset(0% 0% 0% 0%)",
          translateY: "60%",
          duration: 1,
          ease: "power3.out",
        },
        "<",
      )
      .to(
        introMedia,
        {
          translateY: 0,
          ease: "power2.inOut",
          opacity: 0,
          duration: 1.1,
        },
        "+=.5",
      )
      .to(
        introText,
        {
          translateY: 0,
          ease: "power2.inOut",
          duration: 1.1,
        },
        "<",
      )
      .to(
        introText,
        {
          scale: 0.8,
          clipPath: "inset( 0 100% 0 0)",
          duration: 1,
          ease: "power3.out",
        },
        "+=.5",
      )
      .to(introSequence, { opacity: 0, duration: 0.5 });
  } else {
    if (document.querySelector("body").classList.contains("homepage")) {
      loadHome();
    }
  }

  function loadHome() {
    getAjax("/ajax/home.php", function (data) {
      document.querySelector("main #content").innerHTML = data;
      loadInit();
      homeInit();
      overlayInit();
      snapScrollInit();
      scrollingLogosInit();
      let heroEl = document.querySelectorAll(".hero");
      heroEl.forEach((hero) => {
        heroTextInit(hero);
      });
      let twoColEls = document.querySelectorAll(".text-block .two-column");
      twoColEls.forEach((el) => {
        twoColumnTextInit(el);
      });
      let textBlockColumns = document.querySelectorAll(
        ".text-block .column:not(.two-column .column)",
      );
      textBlockColumns.forEach((el) => {
        textBlockColumnInit(el);
      });
      document.body.classList.remove("hide_footer");
    });
  }

  async function getAtlantaInfo() {
    // --- Time ---
    const now = new Date();
    const options = {
      timeZone: "America/New_York",
      hour: "numeric", // 1 or 2 digits as needed
      minute: "2-digit",
      hour12: true,
    };
    const time = new Intl.DateTimeFormat("en-US", options).format(now);

    // --- Temperature (Open-Meteo, no key needed) ---
    const res = await fetch(
      "https://api.open-meteo.com/v1/forecast?latitude=33.749&longitude=-84.388&current=temperature_2m&temperature_unit=fahrenheit",
    );
    const data = await res.json();
    const temp = Math.round(data.current.temperature_2m); // round to nearest integer

    if (timeElParent) {
      const timeEl = timeElParent.querySelector("p");
      if (timeEl) {
        timeEl.textContent = `ATLANTA - ${time} ${temp}°`;
        timeElParent.classList.remove("hidden");
      }
    }
  }

  // Create a scrollTrigger that fades out the time element when the footer gets in the viewport
  let timeElParent = document.querySelector(".time");
  if (typeof timeElParent != "undefined" && timeElParent != null) {
    getAtlantaInfo();

    ScrollTrigger.create({
      trigger:
        innerWidth > 932
          ? document.querySelector("footer .inner")
          : document.querySelector(".hero"),
      start: innerWidth > 932 ? "top bottom" : "bottom bottom-=100",
      end: innerWidth > 932 ? "bottom top" : "bottom bottom+=100",
      markers: false,
      onEnter: () => gsap.to(timeElParent, { autoAlpha: 0, duration: 0.2 }),
      onLeaveBack: () => gsap.to(timeElParent, { autoAlpha: 1, duration: 0.2 }),
    });
  }

  const bioButton = document.querySelector("a.bioButton");
  const bioSection = document.getElementById("bioSection");

  if (bioButton && bioSection) {
    console.log("Creating ScrollTrigger for bio section");
    ScrollTrigger.create({
      trigger: bioSection,
      start: "top bottom-=100",
      onEnter: () => {
        gsap.to(bioButton, { autoAlpha: 0, duration: 0.3, ease: "power1.out" });
      },
      onLeaveBack: () => {
        gsap.to(bioButton, { autoAlpha: 1, duration: 0.3, ease: "power1.out" });
      },
    });
  }

  // overlay links

  function overlayInit() {
    let overlayLinks = document.querySelectorAll(".openOverlay");
    overlayLinks.forEach((overlayLink) => {
      overlayLink.addEventListener("click", function (e) {
        e.preventDefault();
        let id = overlayLink.getAttribute("data-id");
        let reel = overlayLink.getAttribute("data-reel");
        getAjax("/getItem.php?id=" + id, function (data) {
          if (reel === "yes") {
            overlayInner.classList.add("reel");
          }
          overlayInner.innerHTML = data;
          openOverlay();
          let videoPlayerEl = overlayInner.querySelector(".videoplayer");
          if (typeof videoPlayerEl != "undefined" && videoPlayerEl != null) {
            videoControls(videoPlayerEl);
            let videoEl = videoPlayerEl.querySelector("video");
            console.log("Video element in overlay:", videoEl);
            if (typeof videoEl != "undefined" && videoEl != null) {
              if (videoEl.classList.contains("sizeload")) {
                sizeloadVideo(videoEl, "yes");
              }
              videoEl.play();
            }
          }
        });
      });
    });
  }

  overlayInit();

  //hamburger menu toggle
  if (typeof menuBtn != "undefined" && menuBtn != null) {
    menuBtn.addEventListener(
      "click",
      function (event) {
        event.preventDefault();

        const circleDrawer = document.querySelector(".circles #drawer");

        // menuBtn is handling two states - main navigation and cirle drawer, if drawer is open, close it, if not toggle menu
        if (
          typeof circleDrawer != "undefined" &&
          circleDrawer != null &&
          circleDrawer.classList.contains("open")
        ) {
          circleDrawer.classList.remove("open");
          menuBtn.querySelector("p").innerText = "MENU";

          // reset the circle animation
          if (animateCirclesRef) animateCirclesRef(false);

          /*
          document.querySelectorAll(".circle.selected").forEach((c) => {
            c.classList.remove("selected");
          });

          setTimeout(function () {
            // remove active class from all #drawer .service elements
            document.querySelectorAll("#drawer .service").forEach((s) => {
              s.classList.remove("active");
            });
          }, 500);

		  */
          return;
        }

        document.body.classList.toggle("menuOn");
        if (document.body.classList.contains("menuOn")) {
          menuBtn.querySelector("p").innerText = "CLOSE";
        } else {
          menuBtn.querySelector("p").innerText = "MENU";
        }
      },
      true,
    );
  }

  // close overlay
  if (typeof overlay != "undefined" && overlay != null) {
    overlayCloser.addEventListener(
      "click",
      function (event) {
        event.preventDefault();
        closeOverlay();
      },
      true,
    );
  }

  //autoplay/hover roster list
  const rosterCells = document.querySelectorAll(".talent .cell");
  const rosterListLinks = document.querySelectorAll(".talent li a");
  let rosterInterval = null;
  let currentRosterIndex = 0;

  function activateRosterItem(index) {
    rosterCells.forEach((cell, i) => {
      cell.classList.remove("active");
      // Pause all OTHER videos safely
      if (i !== index) {
        let vid = cell.querySelector("video");
        if (vid && !vid.paused) {
          vid.pause();
        }
      }
    });
    rosterListLinks.forEach((l) => l.classList.remove("active"));

    const rosterCell = rosterCells[index];
    const link = rosterListLinks[index];

    if (rosterCell && rosterCell.classList.contains("hasautovideo")) {
      playAutoVideo(rosterCell);
    }
    if (rosterCell) rosterCell.classList.add("active");
    link.classList.add("active");
  }

  function startRosterInterval() {
    /*
	let editorDetailCheck = document.querySelector(".editor_grid");
    if (typeof editorDetailCheck != "undefined" && editorDetailCheck != null) {
      // don't start auto roster on editor detail pages
      return;
    }
	  */
    if (rosterInterval) clearInterval(rosterInterval);
    rosterInterval = setInterval(() => {
      currentRosterIndex = (currentRosterIndex + 1) % rosterListLinks.length;
      activateRosterItem(currentRosterIndex);
    }, 3000); // Change every 3 seconds
  }

  function stopRosterInterval() {
    if (rosterInterval) clearInterval(rosterInterval);
  }

  if (rosterListLinks.length > 0) {
    if (innerWidth > 768) {
      rosterListLinks.forEach((link, idx) => {
        link.addEventListener("mouseenter", () => {
          stopRosterInterval();
          currentRosterIndex = idx;
          activateRosterItem(idx);
        });
        link.addEventListener("mouseleave", () => {
          startRosterInterval();
        });
      });
    }

    // Pick a random starting index
    currentRosterIndex = Math.floor(Math.random() * rosterListLinks.length);
    activateRosterItem(currentRosterIndex);
    startRosterInterval();
  }

  /*
  // Project detail video
  let projectHeroCell = document.querySelector(
    ".project-hero .cell.click-to-play",
  );
  if (typeof projectHeroCell != "undefined" && projectHeroCell != null) {
    setTimeout(function () {
      projectHeroCell.classList.add("playing");
    }, 500);
  }
	*/

  // Project hero Flickity carousel
  let projectHeroCarousel = document.querySelector(".project-hero-carousel");
  if (
    typeof projectHeroCarousel != "undefined" &&
    projectHeroCarousel != null
  ) {
    let initialIndex =
      parseInt(projectHeroCarousel.getAttribute("data-initial-index")) || 0;

    let heroFlkty = new Flickity(projectHeroCarousel, {
      cellSelector: ".carousel-slide",
      initialIndex: initialIndex,
      wrapAround: true,
      prevNextButtons: false,
      pageDots: false,
      draggable: false,
      adaptiveHeight: false,
      cellAlign: "center",
      percentPosition: false,
      selectedAttraction: 0.01,
      friction: 0.25,
    });

    // I want to add a hover state to each carousel slide that isn't active, it should slightly transform toward the center of the screen.  If it is near the right side of the viewport it should transform X -50px, if it is near the left side it should transform X 50px.  If it is the selected slide, not transform
    let carouselSlides =
      projectHeroCarousel.querySelectorAll(".carousel-slide");
    carouselSlides.forEach((slide) => {
      slide.addEventListener("mouseenter", () => {
        if (slide.classList.contains("is-selected")) {
          // do nothing if it's the selected slide
        } else {
          let rect = slide.getBoundingClientRect();
          let slideCenter = rect.left + rect.width / 2;
          let viewportCenter = window.innerWidth / 2;
          if (slideCenter < viewportCenter) {
            slide.classList.add("hover-left");
          } else {
            slide.classList.add("hover-right");
          }
        }
      });
      slide.addEventListener("mouseleave", () => {
        slide.classList.remove("hover-left", "hover-right");
      });
    });

    // Advance to clicked slide if not already selected
    heroFlkty.on(
      "staticClick",
      function (event, pointer, cellElement, cellIndex) {
        if (cellElement && cellIndex !== heroFlkty.selectedIndex) {
          cellElement.classList.remove("hover-left", "hover-right");
          heroFlkty.select(cellIndex);
        }
      },
    );

    // on change we need to update the .project-hero h1 with the new slide's data-title attribute, and if that attribute is empty, hide the h1 with a fade
    heroFlkty.on("change", function (index) {
      let selectedSlide = heroFlkty.selectedElement;
      let slug = selectedSlide.getAttribute("data-slug");
      if (slug) {
        window.history.replaceState(null, null, `/project/${slug}`);
      }
      let title = selectedSlide.getAttribute("data-title");
      let titleEl = document.querySelector(".project-hero h1");
      if (!titleEl) return;

      // Pause all videos in slides except the active one
      const allSlides = projectHeroCarousel.querySelectorAll(".carousel-slide");
      allSlides.forEach((slide) => {
        if (slide !== selectedSlide) {
          const video = slide.querySelector("video");
          if (video && !video.paused) {
            video.pause();
          }
        }
      });

      // Play video in the active slide if exists and not already playing
      let videoEl = selectedSlide.querySelector("video");
      if (videoEl && videoEl.paused) {
        videoEl.play();
      }

      // Fade out, then update, then fade in (or hide)
      gsap.to(titleEl, {
        autoAlpha: 0,
        duration: 0.25,
        onComplete: () => {
          if (title && title.trim() !== "") {
            titleEl.textContent = title;
            gsap.to(titleEl, { autoAlpha: 1, duration: 0.4, display: "block" });
          } else {
            titleEl.textContent = "";
            gsap.set(titleEl, { display: "none" });
          }
        },
      });
    });

    /*

    // Navigate to project on static slide click
    heroFlkty.on(
      "staticClick",
      function (event, pointer, cellElement, cellIndex) {
        if (cellElement) {
          let link = cellElement.getAttribute("data-link");
          if (link && link !== "") {
            window.location.href = link;
          }
        }
      },
    );

	*/
  }

  // Snap scroll

  function snapScrollInit() {
    const mainSections = Array.from(
      document.querySelectorAll(".scroll-section"),
    );
    let snapscrollSection = document.querySelector(".snapscroll");

    if (snapscrollSection && mainSections.length > 0 && innerWidth > 932) {
      /*

    // Calculate the total scrollable distance of the snap region
    const getSnapPoints = () => {
      const containerTop = snapscrollSection.offsetTop;
      const containerHeight =
        snapscrollSection.scrollHeight - window.innerHeight;

      // Build normalized snap points (0 to 1) for each section
      // relative to the ScrollTrigger's progress
      return mainSections.map((section) => {
        return (section.offsetTop - containerTop) / containerHeight;
      });
    };

    ScrollTrigger.create({
      trigger: snapscrollSection,
      start: "top top",
      end: "bottom bottom",
      markers: false,
      snap: {
        snapTo: (progress, self) => {
          const points = getSnapPoints();
          // Find the closest snap point to current progress
          let closest = points[0];
          let minDist = Math.abs(progress - closest);
          for (let i = 1; i < points.length; i++) {
            const dist = Math.abs(progress - points[i]);
            if (dist < minDist) {
              minDist = dist;
              closest = points[i];
            }
          }
          return closest;
        },
        duration: { min: 0.1, max: 0.3 },
        delay: 0,
        ease: "power1.inOut",
        inertia: false, // snap immediately rather than waiting for momentum
      },
    });

	*/

      // create a scrollTrigger to pin each mainSection
      mainSections.forEach((section, idx) => {
        ScrollTrigger.create({
          trigger: section,
          start: "top top",
          end: "bottom top",
          pin: true,
          pinSpacing: idx === mainSections.length - 1, // pinSpacing true only for last section
        });
      });
    }
  }

  snapScrollInit();

  /*

  // Snap scroll
  const SWIPE_THRESHOLD = 30;
  const mainSections = Array.from(document.querySelectorAll(".scroll-section"));
  const lastSection = mainSections[mainSections.length - 1];
  let touchStartY = 0;
  let lastTouchY = 0;
  let touchDirection = 0;
  let isSnapping = false;
  let currentSnapTween = null;
  let snapTweenStartTime = null;
  let currentTargetIndex = -1;
  let snapperActive = true;

  function snapScrollInit() {
    function isMobileDevice() {
      return /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
    }

    function setViewportHeight() {
      const vh = window.innerHeight * 0.01;
      document.documentElement.style.setProperty("--vh", vh + "px");
      ScrollTrigger.refresh();
      if (isSnapping && currentTargetIndex >= 0)
        touchSnapToTarget(currentTargetIndex);
    }

    function touchSnapToTarget(targetIndex) {
      const panelTops = mainSections.map((section) => section.offsetTop);
      if (targetIndex == null) {
        const scroll = Math.round(window.scrollY);
        let currentIndex = panelTops.findIndex((top) => scroll < top);
        if (currentIndex == -1) {
          currentIndex = panelTops.length;
          if (
            touchDirection > 0 ||
            scroll > lastSection.offsetTop + lastSection.offsetHeight
          ) {
            return;
          }
        }

        currentIndex--;
        targetIndex = Math.min(
          Math.max(currentIndex + touchDirection, 0),
          panelTops.length - 1,
        );
      }

      currentTargetIndex = targetIndex;
      const target = panelTops[currentTargetIndex];
      if (target !== scroll) {
        snapTo(target, 0.4, 0, true);
      }
    }

    function snapTo(
      targetY,
      duration,
      resetDelay,
      blockOverflow = false,
      pauseScrollTrigger = false,
    ) {
      if (currentSnapTween?.isActive()) {
        currentSnapTween.kill();
        duration = Math.max(
          0,
          duration - (Date.now() - snapTweenStartTime) / 1000,
        );
      }

      isSnapping = true;
      const isForward = targetY > window.scrollY;

      if (blockOverflow) {
        document.body.style.overflow = "hidden";
        setTimeout(() => {
          document.body.style.overflow = "";
        }, duration / 2);
      }

      if (pauseScrollTrigger) ScrollTrigger.disable();
      snapTweenStartTime = Date.now();
      currentSnapTween = gsap.to(window, {
        scrollTo: targetY,
        duration: duration,
        ease: "power2.out",
        onComplete: () => {
          if (pauseScrollTrigger) {
            ScrollTrigger.enable();
          }

          setTimeout(() => {
            isSnapping = false;
          }, resetDelay * 1000);
        },
      });
    }

    if (isMobileDevice()) {
      setViewportHeight();
      window.addEventListener("resize", setViewportHeight);
      window.addEventListener("orientationchange", setViewportHeight);
    }

    window.addEventListener(
      "touchstart",
      (e) => {
        if (isSnapping) {
          if (e.cancelable) e.preventDefault();
          return;
        }
        touchStartY = lastTouchY = e.touches[0].clientY;
        touchDirection = 0;
      },
      { passive: false },
    );

    window.addEventListener(
      "touchmove",
      (e) => {
        const currentY = e.touches[0].clientY;
        const delta = lastTouchY - currentY;
        if (Math.abs(delta) > 5) {
          touchDirection = delta > 0 ? 1 : 0;
        }

        lastTouchY = currentY;
        if (isSnapping && e.cancelable) e.preventDefault();
      },
      { passive: false },
    );

    window.addEventListener(
      "touchend",
      (e) => {
        if (isSnapping) {
          if (e.cancelable) e.preventDefault();
          return;
        }

        const deltaY = touchStartY - e.changedTouches[0].clientY;
        if (Math.abs(deltaY) < SWIPE_THRESHOLD) return;
        touchSnapToTarget();
      },
      { passive: false },
    );

    window.addEventListener(
      "keydown",
      (e) => {
        if (
          [
            "ArrowDown",
            "ArrowUp",
            "PageDown",
            "PageUp",
            "Home",
            "End",
          ].includes(e.key)
        ) {
          const panelTops = mainSections.map((section) => section.offsetTop);
          const scroll = Math.round(window.scrollY);
          const direction =
            e.key === "ArrowDown" || e.key === "PageDown"
              ? 1
              : e.key === "ArrowUp" || e.key === "PageUp"
                ? -1
                : e.key === "Home"
                  ? -Infinity
                  : e.key === "End"
                    ? Infinity
                    : 0;
          let currentIndex = panelTops.findIndex(
            (top) => scroll + (direction > 0 ? 0 : -1) < top,
          );
          if (currentIndex === -1) {
            snapperActive = false;
            return;
          }
          if (currentIndex == 0 && direction < 0 && scroll <= panelTops[0]) {
            snapperActive = false;
            return;
          }

          e.preventDefault();
          let targetIndex;
          if (!snapperActive) {
            snapperActive = true;
            targetIndex = currentIndex;
          } else {
            if (direction > 0) {
              currentIndex--;
            }

            if (direction === Infinity) {
              targetIndex = panelTops.length - 1;
            } else if (direction === -Infinity) {
              targetIndex = 0;
            } else {
              targetIndex = Math.min(
                Math.max(currentIndex + direction, 0),
                panelTops.length - 1,
              );
            }
          }

          snapTo(panelTops[targetIndex], 0.8, 0);
        }
      },
      { passive: false },
    );

    window.addEventListener(
      "wheel",
      (e) => {
        if (isSnapping) {
          e.preventDefault();
          return;
        }

        const scroll = Math.round(window.scrollY);
        const direction = e.deltaY > 0 ? 1 : -1;
        const panelTops = mainSections.map((section) => section.offsetTop);
        let currentIndex = panelTops.findIndex(
          (top) => scroll + (direction > 0 ? 0 : -1) < top,
        );

        // if scrolling back up and get to the top of the first slide, allow normal scroll to continue so user can access header
        if (currentIndex == 0 && direction < 0 && scroll <= panelTops[0]) {
          snapperActive = false;
          return;
        }

        if currentIndex == -1) {
          currentIndex = panelTops.length;
          if (direction > 0 || scroll > lastSection.offsetTop) {
            snapperActive = false;
            return;
          }
        }

        e.preventDefault();
        let targetIndex;
        if (!snapperActive) {
          snapperActive = true;
          targetIndex = currentIndex;
        } else {
          if (direction > 0) {
            currentIndex--;
          }
          targetIndex = Math.min(
            Math.max(currentIndex + direction, 0),
            panelTops.length - 1,
          );
        }

        const target = panelTops[targetIndex];
        if (target !== scroll) {
          snapTo(target, 0.8, 0.4);
        }
      },
      { passive: false },
    );
  }

  let snapscrollSection = document.querySelectorAll(".snapscroll");

  if (snapscrollSection.length > 0) {
    ScrollTrigger.create({
      trigger: snapscrollSection,
      start: "top 50%",
      endTrigger: snapscrollSection,
      end: "bottom top",
      onEnter: () => {
        snapScrollInit();
      },
    });
  }

  */

  // Handle browser back/forward buttons
  window.addEventListener("popstate", async (event) => {
    const url = window.location.pathname;
    await loadContent(url);
  });

  const pageCache = new Map();
  const CACHE_EXPIRY_MS = 5 * 60 * 1000; // 5 minutes in milliseconds

  function pushStateInit() {
    // top level pages
    let pushStateLinks = document.querySelectorAll(".pushstate");
    if (typeof pushStateLinks != "undefined" && pushStateLinks != null) {
      pushStateLinks.forEach((link) => {
        link.addEventListener("click", (e) => {
          e.preventDefault();
          let url = link.getAttribute("href");
          loadContent(url);
          closeOverlay();
        });
      });
    }
  }

  pushStateInit();

  async function loadContent(url) {
    // Prevent loading if already in progress
    if (loadContent.isLoading) return;
    loadContent.isLoading = true;

    try {
      // apply any resets
      closeNav();

      const parentEl = document.querySelector("section#content");

      // Start loading content immediately
      const [content] = await Promise.all([
        (async () => {
          const cached = pageCache.get(url);
          const now = Date.now();
          if (cached && now - cached.timestamp < CACHE_EXPIRY_MS) {
            return Promise.resolve(cached.content);
          }
          const response = await fetch(`/content.php?page=${url}`);
          if (!response.ok)
            throw new Error(`HTTP error! status: ${response.status}`);
          const text = await response.text();
          pageCache.set(url, { content: text, timestamp: now });
          return text;
        })(),
        gsap
          .to(parentEl, {
            opacity: 0,
            duration: 0.3,
            ease: "power1.out",
          })
          .then(),
      ]);

      body.classList.remove(
        "projectpage",
        "textpage",
        "homepage",
        "intro_playing",
      );

      // Update content and fade in
      parentEl.innerHTML = content;

      // general functions
      loadInit();
      animationInit();
      pushStateInit();
      playFullVideoInit();
      gridTitleAnimation();

      // colect page specific vars
      let newContentEl = parentEl.querySelector("article.inner");
      let newBodyClass = newContentEl.getAttribute("data-bodyclass");
      let bgColor = newContentEl.getAttribute("data-bgcolor");
      let primaryColor = newContentEl.getAttribute("data-primarycolor");

      // apply updated body vars
      document.body.style.backgroundColor = bgColor;
      document.body.style.color = primaryColor;

      if (newBodyClass != "") {
        body.classList.add(...newBodyClass.split(" ")); // Add new classes while keeping existing ones
      }

      // page specific functions
      let arRowsEl = newContentEl.querySelector(".ar-rows");
      if (typeof arRowsEl != "undefined" && arRowsEl != null) {
        let arRowsEls = newContentEl.querySelectorAll(".ar-rows");
        arRows(arRowsEls);
        arRowsReveal();
      }

      let masonGrids = newContentEl.querySelector(".masongrid");
      if (typeof masonGrids != "undefined" && masonGrids != null) {
        W;
        masonryInit();
      }

      let marqueeCheck = newContentEl.querySelector(".marquee .carousel");
      if (typeof marqueeCheck != "undefined" && marqueeCheck != null) {
        marqueeInits();
      }

      let textPageCheck = parentEl.querySelector(".textpage");
      if (typeof textPageCheck != "undefined" && textPageCheck != null) {
        textPageAnimation();
      }

      let projectPageCheck = parentEl.querySelector(".modules");
      if (typeof projectPageCheck != "undefined" && projectPageCheck != null) {
        projectSidebarsInit();
        projectDetailAnimation();

        // Re-init project hero carousel after SPA navigation
        let newHeroCarousel = parentEl.querySelector(".project-hero-carousel");
        if (typeof newHeroCarousel != "undefined" && newHeroCarousel != null) {
          let newInitialIndex =
            parseInt(newHeroCarousel.getAttribute("data-initial-index")) || 0;
          let newHeroFlkty = new Flickity(newHeroCarousel, {
            cellSelector: ".carousel-slide",
            initialIndex: newInitialIndex,
            wrapAround: true,
            prevNextButtons: false,
            pageDots: false,
            draggable: true,
            adaptiveHeight: false,
            cellAlign: "center",
            percentPosition: false,
          });

          newHeroFlkty.on(
            "staticClick",
            function (event, pointer, cellElement, cellIndex) {
              if (cellElement) {
                let link = cellElement.getAttribute("data-link");
                if (link && link !== "") {
                  window.location.href = link;
                }
              }
            },
          );
        }
      }

      let homepageCheck = parentEl.querySelector(".home");
      if (typeof homepageCheck != "undefined" && homepageCheck != null) {
        gsap.set(headerLogo, { opacity: 0 });
        homepageInit();
      } else {
        // make sure logo is visible, may need to do a check for homepage here
        gsap.set(headerLogo, { opacity: 1 });
      }

      gsap.to(parentEl, {
        opacity: 1,
        duration: 0.5,
      });

      // Update history
      history.pushState(null, null, url);

      // scroll to top of page
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 100);

      return content;
    } catch (error) {
      console.error("Failed to load content:", error);
      // Fade back in if there's an error
      const parentEl = document.querySelector("section#content");
      gsap.to(parentEl, { opacity: 1, duration: 0.5 });
    } finally {
      loadContent.isLoading = false;
    }
  }
});
